'use strict';

angular.module('ringbaPortal.services').factory('callbackService', callbackService);

function callbackService($http, ngAuthSettings, promiseCacheService) {
  'ngInject';
  
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const eventCallBackCodes = [ {
    label: 'Incoming',
    code: 'incoming'
  }, {
    label: 'Connected (Answered)',
    code: 'connected'
  },{
    label: 'Completed',
    code: 'completed'
  }, {
    label: 'Converted',
    code: 'converted'
  },{
    label: 'Error',
    code: 'error'
  },
  {
    label: 'Payout',
    code: 'payout'
  },
  {
    label: 'Recording',
    code: 'recording'
  },
  {
    label: 'Finalized',
    code: 'finalized'
  },
  {
    label: 'Transcribed',
    code: 'transcribed'
  },
  {
    label: 'Analyzed',
    code: 'analyzed'
  }];

  const columnSettings = {
    name: {
      class: 'tablesort-sortable',
      stSort: 'name',
      displayName: 'NAME_TEXT'
    },
    eventCode: {
      class: 'tablesort-sortable',
      stSort: 'eventCode',
      displayName: 'PIXELS_ACTIVE_EVENT_CODE'
    },
    method: {
      class: 'tablesort-sortable',
      stSort: 'method',
      displayName: 'PIXELS_ACTIVE_METHOD'
    },
    pixelUrl: {
      class: 'tablesort-sortable',
      stSort: 'pixelUrl',
      displayName: 'PIXELS_ACTIVE_URL'
    }
  };

  const defaultColumns = [
    'name',
    'eventCode',
    'method',
    'pixelUrl'
  ];

  // var macroPromise = null;

  const userDefinedMacro = '[tag:User:]';
  const macroCacheKey = 'MacroPromise';

  const service = {
    columnSettings: columnSettings,
    defaultColumns: defaultColumns,
    getEventCallBacks: getEventCallBacks,
    getEventCallBack: getEventCallBack,
    getEventCallBackMacros: getEventCallBackMacros,
    createEventCallBack: createEventCallBack,
    deleteEventCallBack: deleteEventCallBack,
    getReferences: getReferences,
    updateEventCallBack: updateEventCallBack,
    eventCallBackCodes: eventCallBackCodes,
    userDefinedMacro: userDefinedMacro,
    parseEventCallBack: parseEventCallBack,
    cleanMacros: cleanMacros,
    linkToItem: linkToItem,
    unLinkItem: unLinkItem,
    macros: null
  };
  return service;

  function getEventCallBacks(accountId) {
    const url = serviceBaseUri + accountId + '/eventCallBacks';
    return $http.get(url);
  }

  function getEventCallBack(accountId, eventCallBackId) {
    const url = _serviceBaseUrl(accountId, eventCallBackId);
    return $http.get(url);
  }

  function cleanMacros(accountId) {
    promiseCacheService.clean(macroCacheKey);
    return getEventCallBackMacros(accountId);
  }

  function getEventCallBackMacros(accountId) {
    const url = serviceBaseUri + accountId + '/eventCallBacks/macros';
    return promiseCacheService.getCallWithCachedPromise(macroCacheKey, url, 120,
      function (response) {
        service.macros = response.data.macros;
      },
      function () {
        service.macros = null;
      });

  }

  function createEventCallBack(accountId, eventCallBack) {
    const url = serviceBaseUri + accountId + '/eventCallBacks';
    return $http.post(url, eventCallBack);
  }

  function deleteEventCallBack(accountId, eventCallBackId) {
    const url = _serviceBaseUrl(accountId, eventCallBackId);
    return $http.delete(url);
  }

  function linkToItem(accountId, eventCallBackId, linkRequest) {
    const url = _serviceBaseUrl(accountId, eventCallBackId) + '/Link';
    return $http.patch(url, linkRequest);
  }

  function unLinkItem(accountId, eventCallBackId, linkRequest) {
    const url = _serviceBaseUrl(accountId, eventCallBackId) + '/UnLink';
    return $http.patch(url, linkRequest);
  }

  function getReferences(accountId, eventCallBackId) {
    const url = _serviceBaseUrl(accountId, eventCallBackId) + '/InboundReferences';
    return $http.get(url);
  }

  function updateEventCallBack(accountId, eventCallBack) {
    const eventCallBackCopy = angular.copy(eventCallBack);
    if (eventCallBackCopy) {
      delete eventCallBackCopy.showEditForm;
    }
    const url = _serviceBaseUrl(accountId, eventCallBackCopy.id);
    return $http.patch(url, eventCallBackCopy);
  }

  function parseEventCallBack(eventCallBack) {
    const baseUrl = eventCallBack.pixelUrl.substring(0, eventCallBack.pixelUrl.indexOf('?'));
    const queryString = eventCallBack.pixelUrl.substring(eventCallBack.pixelUrl.indexOf('?') + 1).split('&');
    const params = [];
    let pair;

    for (let i = queryString.length - 1; i >= 0; i--) {
      pair = queryString[i].split('=');
      params.push({ queryString: decodeURIComponent(pair[0]), macro: decodeURIComponent(pair[1]) });
    }
    return { baseUrl: baseUrl, params: params };
  }

  function _serviceBaseUrl(accountId, eventCallBackId) {
    return serviceBaseUri + accountId + '/eventCallBacks/' + eventCallBackId;
  }
}
